const cryptocurrency = {
  paymentMethodName: 'Kripto Para',
  cryptocurrencyLabel: 'Kripto Para',
  cryptocurrencySelectPlaceholder: 'Kripto paranızı seçin',
  protocolWarning: 'Ödeme seçilenden farklı bir ağ kullanılarak yapılırsa, fonlar kalıcı olarak kaybedilebilir. Lütfen devam etmeden önce <b>cüzdanınızın doğru ağ için yapılandırıldığından emin olun</b>.',
  networkLabel: 'Ağ',
  networkSelectPlaceholder: 'Ağınızı seçin',
  paymentButtonLabel: 'Kripto Para ile Öde',
  amountLocal: 'Yerel tutar',
  amountCrypto: 'Kripto tutar',
  paymentCreatedTitle: 'Ödemeniz oluşturuldu!',
  paymentCreatedSubtitle: 'Siparişinizin tamamlanması uzun sürmeyecek! Bu işlemi onaylamak için aşağıdaki talimatları izleyin.',
  qrCodeInstruction: 'Ödemeyi saniyeler içinde tamamlamak için cüzdanınızda aşağıdaki QR kodunu tarayın',
  qrCodeNetworkNotFound: 'Ağ bulunamadı. Lütfen doğru ağı seçtiğinizden emin olun.',
  networkWarning: '<b>{protocol}</b> kullanarak <b>{cryptocurrency}</b> ödüyorsunuz. Cüzdanınızda doğru ağı seçtiğinizden emin olun, aksi takdirde fonlarınız kaybedilebilir.',
  conversionRate: 'Dönüştürülen değer 1 {currencyExt} = {formattedCryptoRate} {cryptocurrency}. Bu değer gerçek zamanlı olarak hesaplanır ve döviz kuruna bağlı olarak dalgalanabilir.',
  paymentApproved: '<AmountText>{amountLocal}</AmountText> tutarındaki ödemeniz onaylandı.',
  howToPayInfoTitle: 'Kripto ile nasıl ödenir?',
  howToPayOpenApp: 'Cüzdanınızı (uygulama veya uzantı) açın ve Satın Al, Transfer, Gönder veya Öde seçeneğine dokunun.',
  howToPayQrCode: 'QR kodunu tarayın ve gerekli alanları kopyala yapıştır kullanarak doldurun.',
  howToPayNetwork: 'Doğru ağı seçtiğinizden emin olun. Yanlış seçilirse, fonlar kurtarılamayabilir.',
  howToPayConfirmation: 'Durumu cüzdanınızda (Etkinlik/Geçmiş) takip edin veya onay beklemek için bu sayfaya geri dönün.',
  payAgreement1: 'Devam ederek EBANX\'in ',
  serviceTerms: 'Şartlar ve Koşullar',
  payAgreement2: '\'ını kabul etmiş olursunuz.',
  payWithWalletButton: 'Kripto cüzdanı ile öde',
  walletRedirectInstruction: 'Düğmeye tıklayarak ödeme yapabilir ve ödemeyi tamamlamak için yönlendirilirsiniz.',
  manualQrCodeInstruction: 'Veya ödemeye devam etmek için aşağıdaki QR Kodunu manuel olarak tarayın',

};

module.exports = cryptocurrency;
